import { render, staticRenderFns } from "./img-detail-layout.vue?vue&type=template&id=c112a668&scoped=true"
import script from "./img-detail-layout.vue?vue&type=script&lang=js"
export * from "./img-detail-layout.vue?vue&type=script&lang=js"
import style0 from "./img-detail-layout.vue?vue&type=style&index=0&id=c112a668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c112a668",
  null
  
)

export default component.exports